import React, { useEffect, useState } from "react";
import { Card, Spinner, Alert } from "react-bootstrap";
import bookimg1 from "../../../assets/img/bookimg1.jpg";
import { userFollowingList } from "../../../api/userService";
import { useParams, Link } from "react-router-dom"; // ✅ Import Link
import DataTable from "react-data-table-component";

const MEDIA_URL = "https://d3bn54rc14fhr4.cloudfront.net";

export default function FollowingTab() {
  const { userId } = useParams();
  const [searchText, setSearchText] = useState("");
  const [userFollowingListData, setUserFollowingListData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    if (userId) {
      fetchUserFollowing();
    }
  }, [userId]);

  const fetchUserFollowing = async () => {
    setLoading(true);
    setError("");
    setNoData(false);

    try {
      const response = await userFollowingList({ userId });

      if (response?.data && response.data.length > 0) {
        const updatedData = response.data.map((item, index) => ({
          id: index + 1,
          _id: item?.following?._id, // ✅ Store user _id for linking
          fullName: item?.following?.fullName || "-",
          username: item?.following?.username || "-",
          email: item?.following?.email || "-",
          profilePic: item?.following?.profilePic,
          followedOn: new Date(item?.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }),
        }));

        setUserFollowingListData(updatedData);
      } else {
        setUserFollowingListData([]);
        setNoData(true);
      }
    } catch (err) {
      console.error("Error fetching following list:", err);
      setError("An error occurred while fetching following list.");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      name: "Profile",
      minWidth: "280px",
      selector: (row) => row.fullName,
      sortable: true,
      cell: (row) => (
        <>
          <img
            className="table_img rounded-circle img-thumbnail me-2"
            src={row.profilePic ? `${MEDIA_URL}/${row.profilePic}` : bookimg1}
            alt="profile"
            width={50}
            height={50}
          />
          {row.fullName}
        </>
      ),
    },
    {
      name: "Username",
      minWidth: "190px",
      selector: (row) => row.username,
      sortable: true,
      cell: (row) => (
        <Link
          to={`/admin/view-user/${row._id}?tab=basicinfo`}
          className="text-primary"
        >
          {row.username}
        </Link>
      ),
    },
    {
      name: "Email",
      minWidth: "210px",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Followed On",
      minWidth: "180px",
      selector: (row) => row.followedOn,
      sortable: true,
    },
  ];

  const filteredData = userFollowingListData.filter((item) =>
    JSON.stringify(item).toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <React.Fragment>
      <Card>
        <Card.Body className="bookingtable">
          <div className="text-end mb-3">
            <input
              type="text"
              placeholder="Search..."
              className="searchfield"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          {loading ? (
            <div className="text-center my-5">
              <Spinner animation="border" variant="primary" role="status" />
              <div className="mt-2">Loading following list...</div>
            </div>
          ) : error ? (
            <Alert variant="danger" className="text-center">{error}</Alert>
          ) : noData ? (
            <div className="text-center text-muted">No following found.</div>
          ) : (
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              responsive
              className="custom-table"
            />
          )}
        </Card.Body>
      </Card>
    </React.Fragment>
  );
}
